/** Contratos compartilhados entre cliente, servidor e ferramentas. */
export const NEUTRAL_INPUT = { moveX: 0, thrust: 0, fire: false };
/** Codifica um input em 1 byte. */
export function packInput(input) {
    return ((input.moveX + 1) & 0b11) | (((input.thrust + 1) & 0b11) << 2) | (input.fire ? 0b10000 : 0);
}
/** Decodifica o byte produzido por `packInput`. */
export function unpackInput(byte) {
    const moveX = ((byte & 0b11) - 1);
    const thrust = (((byte >> 2) & 0b11) - 1);
    return { moveX, thrust, fire: (byte & 0b10000) !== 0 };
}
//# sourceMappingURL=types.js.map